import React from 'react';
import { Star } from 'lucide-react';
export function SocialProof() {
  const publications = ['VOGUE', 'WELL+GOOD', 'GOOP', 'MINDBODYGREEN', 'FORBES'];
  return <section className="py-10 md:py-12 border-y border-ink/5 bg-cream" data-id="element-162">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8" data-id="element-163">
        <div className="flex items-center gap-4" data-id="element-164">
          <div className="flex" data-id="element-165">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-sand text-sand" data-id="element-166" />)}
          </div>
          <span className="text-sm font-medium tracking-wide text-ink" data-id="element-167">
            +5,000 Mujeres Transformadas
          </span>
        </div>

        <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 md:gap-12 opacity-40 grayscale" data-id="element-168">
          {publications.map(pub => <span key={pub} className="text-xs md:text-base font-serif tracking-[0.2em] uppercase" data-id="element-169">
              {pub}
            </span>)}
        </div>
      </div>
    </section>;
}